import React from 'react';
import connect from 'Shared/connect';
import classnames from 'classnames';
import AccountBox from '../../../../AccountBox';
import Button from 'Shared/Button';
import Overlay from 'Shared/Overlay';
import { setMyMenigoDropdownOpen, setMyMenigoDropdownClose } from '../../../../MyMenigoDropdown/action-creators';
import * as styles from './LoginLogoutButtons.scss';
import * as button from '../../../../../../../styles/objects/buttons.scss';
import { translate } from 'Shared/translate';
import FeedbackButton from 'Shared/Button/Feedback';
import { logout } from '../../../../../../Account/action-creators';
import MyMenigoIcon from '../../../../../..//MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
class LoginButton extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.toggle = () => {
            if (!this.props.isOpen) {
                this.props.setToOpenMyMenigoDropdown();
            }
            else {
                this.props.setToCloseMyMenigoDropdown();
            }
        };
        this.menigoButtonClass = (url) => {
            return (url === this.props.currentPage.url || (this.props.currentPage.url + "/").indexOf(url) == 0) ? classnames(button.base, button.bare, styles.myMenigoButton, styles.current) : classnames(button.base, button.bare, styles.myMenigoButton);
        };
        this.handleOktaLoginClick = () => {
            window.location.href = '/login';
        };
    }
    render() {
        return this.props.isSupplierSalesman ? (React.createElement(FeedbackButton, { type: "button", appearance: "link", onClickWithFeedback: (e, activate) => activate(this.props.logout()), className: styles.supplierSalesmenLogout, href: '/' }, translate('/Account/MyPages/Logout'))) : (this.props.isLoggedIn ?
            React.createElement("a", { href: "/mitt-menigo", className: this.menigoButtonClass(!!this.props.headerViewModel.myMenigoItems[0] ? this.props.headerViewModel.myMenigoItems[0].url : "/") },
                React.createElement(MyMenigoIcon, { name: "user" }),
                translate('/MyMenigo/Header/MyMenigo'))
            :
                React.createElement("div", { className: styles.loginWrapper },
                    React.createElement(Overlay, { enabled: this.props.isOpen, onClose: this.toggle, className: styles.overlayBase, wrapperClassName: styles.overlayWrapper, overlayClassName: styles.overlay },
                        React.createElement("div", { className: classnames(this.props.className) },
                            React.createElement(Button, { onClick: this.handleOktaLoginClick, className: 'ui-test-user-nav-button', appearance: "primary" }, translate('/Account/Login/Header'))),
                        this.props.isOpen && (React.createElement("div", { className: styles.parentDropdown },
                            React.createElement(AccountBox, { close: this.props.setToCloseMyMenigoDropdown, isCloseButton: false }))))));
    }
}
export default connect((state) => ({
    isLoggedIn: !!state.currentUser && state.currentUser.isLoggedIn,
    headerViewModel: state.appShellData.header,
    isOpen: state.myMenigoBox.isOpen,
    isSupplierSalesman: state.currentUser.isSupplierSalesman,
    currentPage: state.currentPage
}), (dispatch) => ({
    setToOpenMyMenigoDropdown: () => dispatch(setMyMenigoDropdownOpen()),
    setToCloseMyMenigoDropdown: () => dispatch(setMyMenigoDropdownClose()),
    logout: () => dispatch(logout()),
}))(LoginButton);
